import * as React from 'react'
import { ProgressBar } from './ui'
import { money, type OpsUnit } from './operationsModel'
import { calculateInventorySummary } from './unitPaybackModel'

export function InventorySummary({ units }: { units: OpsUnit[] }) {
  const summary = calculateInventorySummary(units)
  const note = summary.costedUnits < summary.totalUnits
    ? `Payoff and profit use ${summary.costedUnits} of ${summary.totalUnits} units with a positive purchase price and recorded revenue.`
    : undefined
  return <dl className="inventory-summary" aria-label="Inventory summary">
    <div><dt>Units</dt><dd>{summary.totalUnits}</dd></div>
    <div><dt>Paid off / total</dt><dd title={note}>{summary.paidOffUnits} <span className="inventory-summary-total">/ {summary.totalUnits}</span></dd></div>
    <div><dt>Overall payoff</dt><dd className="ops-unit-payback inventory-summary-payback" title={note}>
      {summary.payback ? <>
        <ProgressBar value={summary.payback.progressPercentage} label="Overall purchase cost paid off" isLabelHidden
          variant={summary.payback.progressPercentage === 100 ? 'success' : 'warning'} />
        <span>{summary.payback.displayPercentage}%</span>
      </> : '—'}
    </dd></div>
    <div><dt>Profit</dt><dd title={note}>{money(summary.profitPence)}</dd></div>
  </dl>
}
